export default __webpack_public_path__ + "static/Checklist-3928a1e3657f8ade0b74510bcb80bd85.pdf";